import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { isNil, isEmpty } from "ramda";

import InvitePresenter from "presenters/InvitePresenter";
import { DEFAULT_INVITE_DETAILS } from "enums";

const FieldValue = ({ field, invite, variant = "h4", component = "span" }) => {
  const valueFromInvite = InvitePresenter?.[field](invite);

  if (InvitePresenter.isEventUpdated(invite) && (isNil(valueFromInvite) || isEmpty(valueFromInvite))) return null;

  const valueToDisplay =
    !invite || !InvitePresenter.isEventUpdated(invite) ? DEFAULT_INVITE_DETAILS?.[field] : valueFromInvite;

  return (
    <Typography className={field} variant={variant} component={component}>
      {valueToDisplay}
    </Typography>
  );
};

FieldValue.propTypes = {
  field: PropTypes.string.isRequired,
  invite: InvitePresenter.shape(),
  variant: PropTypes.string,
  component: PropTypes.string,
};

export default FieldValue;
